export default __webpack_public_path__ + "static/media/pantry2-before1-1920w.9de09980.webp";